// extracted by mini-css-extract-plugin
export default {"link":"LinkButton_link__wF+bt","under_text":"LinkButton_under_text__2+4oc"};